import { useCallback, useState } from 'react';

import { useBinaryState } from '../../../../hooks/use-binary-state';
import { getImportSummary } from '../api';

/**
 * @returns {{
 *    data: import("../types/types").ImportSummaryData | object,
 *    hasError: boolean,
 *    fetchSummary: (jobId: string, onStart: () => void, onFail: (error: object) => void) => void,
 *    isGetSummaryLoading: boolean
 * }}
 */
export const useGetImportSummary = () => {
  const [data, setData] = useState({});
  const [hasError, setHasError, setHasNoError] = useBinaryState();
  const [isGetSummaryLoading, startLoading, stopLoading] = useBinaryState(true);

  const fetchSummary = useCallback(
    /**
     * @param {string} jobId
     * @param {() => void} onStart
     * @param {(error: object) => void} onFail
     * @returns {void}
     */
    (jobId, onStart, onFail) => {
      onStart();
      startLoading();
      setHasNoError();
      getImportSummary(jobId)
        .then((response) => {
          setData(response ?? {});
        })
        .catch((error) => {
          setHasError();
          onFail(error);
        })
        .finally(stopLoading);
    },
    [setHasNoError, setHasError, startLoading, stopLoading],
  );

  return {
    data,
    hasError,
    fetchSummary,
    isGetSummaryLoading,
  };
};
